import { jsx as _jsx } from "react/jsx-runtime";
import { DefaultChartStyles, determineTimeStringByTimezone } from '../../utils';
import differenceInHours from 'date-fns/differenceInHours';
import { DateTime } from 'luxon';
const ChartDateTickFormat = ({ x, y, payload, locale, ianaTimeZoneCode, isReport, dateOnly, }) => {
    const { value: timestamp, rotateTick, fromDate, toDate } = payload;
    const timestampInDateOrNumber = typeof timestamp === 'string'
        ? DateTime.fromISO(timestamp).toJSDate()
        : timestamp;
    const textAnchor = rotateTick ? 'end' : 'middle';
    const isLessThan48Hours = Math.abs(differenceInHours(fromDate, toDate)) <= 48;
    let tickText;
    if (isLessThan48Hours && !dateOnly) {
        tickText = determineTimeStringByTimezone(timestampInDateOrNumber, locale.timeFormat, ianaTimeZoneCode);
    }
    else {
        tickText = determineTimeStringByTimezone(timestampInDateOrNumber, 'MMM dd', ianaTimeZoneCode);
    }
    let tickAngle = '';
    if (rotateTick) {
        tickAngle = 'rotate(-60)';
    }
    return (_jsx("g", Object.assign({ transform: `translate(${x},${y})` }, { children: _jsx("text", Object.assign({ x: 0, y: 0, dy: rotateTick ? '5' : '10', textAnchor: textAnchor, fill: DefaultChartStyles.tick.fill, fontSize: isReport
                ? DefaultChartStyles.tick.reportFontSize
                : DefaultChartStyles.tick.fontSize, stroke: "none", transform: tickAngle }, { children: tickText }), void 0) }), void 0));
};
export default ChartDateTickFormat;
